'use client';

import { Box } from '@chakra-ui/react';

export default function FilterBadge({
  count,
  onClear,
  className,
}: {
  count?: number;
  onClear?: () => void;
  className?: string;
}) {
  if (!count) return null;
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        if (onClear) {
          onClear();
        }
      }}
      as="button"
      position="absolute"
      right={1}
      top={-3}
      borderRadius="xl"
      bg="black"
      color="white"
      display="flex"
      alignItems="center"
      gap={1}
      px={2}
      py={1}
      pr={onClear ? 1 : 2}
      className={className}
      // pointerEvents={onClear ? 'auto' : 'none'}
    >
      <Box>{count}</Box>
      {onClear ? (
        <Box borderRadius="full" px={1} py={0} color="black" bg="gray.100">
          ×
        </Box>
      ) : null}
    </Box>
  );
}
